import {Flag} from '~/entities/operations-fiat';
import {RsnPicker} from '~/library/ui-kit';
import HintType = RsnPicker.HintType;

export const transformFlagsToHint = (
    flags: Flag[],
    defaultHint?: string
): {
    hint?: string;
    hintType?: HintType;
} => {
    const sortedFlags = [...flags].sort((a, b) => {
        if (a.level === 'problem' && b.level === 'warning') return -1;
        if (a.level === 'warning' && b.level === 'problem') return 1;
        return 0;
    });

    const firstFlag = sortedFlags[0];

    if (!firstFlag) return defaultHint ? {hint: defaultHint, hintType: 'default'} : {};

    const hint = (() => {
        switch (firstFlag.reasonCode) {
            case 'IBAN_PENDING':
                return 'Your IBAN is pending';
            case 'ADDRESS_UNVERIFIED':
                return 'Need to verify the address';
            case 'ADDRESS_PENDING':
                return 'Address is on verification';
            case 'CARD_PENDING':
                return 'On verification';
            case 'CARD_UNVERIFIED':
                return 'Need to verify';
        }
    })();

    const hintType: HintType = (() => {
        switch (firstFlag.level) {
            case 'problem':
                return 'danger';
            case 'warning':
                return 'warning';

            default:
                return 'default';
        }
    })();

    return {hint, hintType};
};
